// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/financial/tax_jurisdiction.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/financial/tax_jurisdiction.proto.
 */
export const file_proto_model_financial_tax_jurisdiction = /*@__PURE__*/
  fileDesc("Cixwcm90by9tb2RlbC9maW5hbmNpYWwvdGF4X2p1cmlzZGljdGlvbi5wcm90bxIGY2FybWVuIpgBCg9UYXhKdXJpc2RpY3Rpb24SFAoMY291bnRyeV9jb2RlGAEgASgJEhIKCnN0YXRlX2NvZGUYAiABKAkSEQoJY2l0eV9jb2RlGAMgASgJEhMKC3Bvc3RhbF9jb2RlGAQgASgJEhkKEWp1cmlzZGljdGlvbl9uYW1lGAUgASgJEhgKEHRheF9hdXRob3JpdHlfaWQYBiABKAlCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw");

/**
 * Describes the message carmen.TaxJurisdiction.
 * Use `create(TaxJurisdictionSchema)` to create a new message.
 */
export const TaxJurisdictionSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_tax_jurisdiction, 0);

